import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import BlogForm from "../../../component/blogForm";
import { useCookies } from "react-cookie";
import axiosInstance from "../../../utils/axios";

export default function BlogManageDetail() {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);

  const fetchBlog = async () => {
    await axiosInstance.get(`/blog/getById/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data[0];
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/blog/update/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      } else {
        await axiosInstance.post(`/blog/create`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
            fetchBlog();
          });
      }
      navigate("/admin/quan-ly-blog");
    } catch (error) {
      message.error(error.message || String(error));
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchBlog();
  }, [id]);

  return (
    <BlogForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
